import { render } from "./IconRefund.vue?vue&type=template&id=76fbeb67"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconRefund.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76fbeb67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76fbeb67', __exports__)) {
    api.reload('76fbeb67', __exports__)
  }
  
  module.hot.accept("./IconRefund.vue?vue&type=template&id=76fbeb67", () => {
    api.rerender('76fbeb67', render)
  })

}


export default __exports__